<template>
  <div class="linkTypePickerPanel" role="listbox" aria-label="选择资源类型">
    <generic-resource-type-picker
      :selected-asset-type="value"
      :type-options="typeOptions"
      @select="onSelect"
    />
  </div>
</template>

<script>
import GenericResourceTypePicker from './GenericResourceTypePicker.vue'

export default {
  name: 'GenericResourceTypePickerPanel',
  components: { GenericResourceTypePicker },
  props: {
    typeOptions: { type: Array, default: () => [] },
    value: { type: String, default: '' },
  },
  methods: {
    onSelect(assetType) {
      this.$emit('select', assetType)
    },
  },
}
</script>

<style scoped>
.linkTypePickerPanel {
  width: 100%;
  margin-top: -1px;
  overflow: hidden;
  border: 1px solid var(--link-line-strong, #e0e0e0);
  border-top: none;
  border-radius: 0 0 var(--link-radius-lg, 16px) var(--link-radius-lg, 16px);
  background: var(--link-card-surface, #fff);
  box-shadow: var(--link-shadow-lg, 0 12px 32px rgba(0, 0, 0, 0.08));
}
</style>
